/**
 * Ventana emergente RIO 360 (Diego 2026-09-18). El Modal genérico de codekit
 * tiene ancho tope (1312 px en xxl) y vive fuera del lienzo RIO, así que en
 * monitores grandes quedaba a escala 1 mientras la pantalla de atrás estaba a
 * 1,35: letra pequeña y media pantalla vacía. Esta ventana se monta en el body,
 * toma LA MISMA escala que tenga el lienzo RIO abierto en ese momento y usa
 * casi todo el ancho. Con onCerrar cierra con Escape (no pasarlo en formularios:
 * una tecla no debe botar lo digitado); el contenido trae su propio Volver.
 * ancho: completa | media | angosta. hoja: panel blanco sin marco, para
 * formularios y detalles cortos. mantener: cerrada, esconde el contenido en vez
 * de desmontarlo; react-hook-form no valida un campo desmontado.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-18
 */
import React, { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import "./riodo.css";

/** Escala vigente del lienzo RIO de la pantalla (1 si no hay o el navegador no soporta zoom) */
const escalaDelLienzo = () => {
  const lienzo = document.querySelector(".riodo-escala .riodo");
  const escala = lienzo ? parseFloat(window.getComputedStyle(lienzo).zoom) : 1;
  return Number.isFinite(escala) && escala > 0 ? escala : 1;
};

//Ancho del panel segun el contenido (px del lienzo, antes de la escala): las
//listas usan todo; un formulario no se estira a lo ancho de la pantalla.
const ANCHOS = { completa: 1640, media: 1000, angosta: 720 };

const Ventanax = ({ isOpen, onCerrar, ancho = "completa", hoja = false, mantener = false, children }) => {
  const escala = useMemo(() => (isOpen ? escalaDelLienzo() : 1), [isOpen]);

  useEffect(() => {
    if (!isOpen || !onCerrar) return undefined;
    const handleTecla = (e) => e.key === "Escape" && onCerrar();
    window.addEventListener("keydown", handleTecla);
    return () => window.removeEventListener("keydown", handleTecla);
  }, [isOpen, onCerrar]);

  if (!isOpen && !mantener) return null;
  return createPortal(
    <div className="riodo rio-ventana-velo" style={isOpen ? { zoom: escala } : { display: "none" }}>
      <div
        className={`rio-ventana${hoja ? " rio-ventana--hoja" : ""}`}
        style={{ width: `min(${ANCHOS[ancho] ?? ANCHOS.completa}px, 100%)` }}
        role="dialog"
        aria-modal="true"
      >
        <div className="rio-ventana-cuerpo">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Ventanax;
